import React from "react";
import Link from "gatsby-link";
import {
  Collapse,
  Container,
  Col,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  Row
} from "reactstrap";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { library, config } from '@fortawesome/fontawesome-svg-core'

import logoNormal from "../../static/img/logo_fischer_marmor_website.png";
import logoDark from "../../static/img/logo_dark_fischer_marmor_website.png";


export default class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
    this.state = {
      collapsed: true
    };

    this.iconStyle = {
      "width": "1.333em"
    }

    this.logo = logoNormal;
    config.autoAddCss = false;
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  closeNavbar() {
    if (this.state.collapsed !== true) {
      this.toggleNavbar();
    }
  }

  render() {
    if (this.props.theming === 'dark') {
      this.logo = logoDark;
    } else {
      this.logo = logoNormal;
    }

    return (
      <header>
        <Navbar className="navigation__navbar" light expand="lg">
          <Container>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse isOpen={!this.state.collapsed} navbar>
              <Nav className="mr-auto" navbar>
                <NavItem>
                  <Link
                    className="nav-link navigation__navlinks"
                    to="/"
                  >
                    Home
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/naturstein-bearbeitung/"
                  >
                    Leistungen
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/granit-arbeitsplatte/"
                  >
                    Küchen
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/outdoorkuechen/"
                  >
                    Outdoor-Küchen
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/ladenbau/"
                  >
                    Ladenbau
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/badezimmergestaltung/"
                  >
                    Bäder
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/kaminverkleidung/"
                  >
                    Innenausbau
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/granit-fensterbank/"
                  >
                    Bauwesen
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/naturstein-reinigung/"
                  >
                    Informationen
                  </Link>
                </NavItem>
                <NavItem>
                  <Link onClick={this.closeNavbar}
                    className="nav-link navigation__navlinks"
                    activeClassName="navigation__navlinks--active"
                    to="/kontakt/"
                  >
                    Kontakt
                  </Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <Container>
          <Row className="branding__row">
            <Col className="mb-4" md="6" xs="8">
              <img className="navbar__logo" width="383" src={this.logo} alt="Logo Fischer Marmor" />
            </Col>
            <Col md="6" xs="12" className="ml-auto">
              <div className="float-md-right">
              <a href="https://www.facebook.com/FischerMarmorGmbH/">
              <FontAwesomeIcon  size="lg" icon={faFacebook} style={this.iconStyle} />
              </a>&nbsp;
              <a href="https://www.instagram.com/fischermarmor">
              <FontAwesomeIcon  size="lg" icon={faInstagram} style={this.iconStyle} />
              </a>&nbsp;
                <a href="tel:+4920452563" className="branding__phonenumber">02045 / 2563</a>&nbsp;<a className="branding__email" href="mailto:#">
                  kontakt@fischermarmor.de
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js